export default __webpack_public_path__ + "static/media/TG.fb3e8746.svg";